import styled from 'styled-components';

export const Wrapper = styled.div``;

export const InfoText = styled.div`
	font-size: 1.6rem;
	margin-bottom: 0.5rem;
`;
